import { setOption } from "../../Utilities/Platform/Options/Options";

export const SYNCHRONISATION = "SYNCHRONISATION";
export const SYNCHRONISATION_PAGE = "SYNCHRONISATION_PAGE";
export const SYNCHRONISATION_OPEN_TIME = "SYNCHRONISATION_OPEN_TIME";
export const SYNCHRONISATION_UPLOADING = "SYNCHRONISATION_UPLOADING";

export type SyncStatus = "running" | "large" | "error" | "stopped";

interface UpdateSynchroniseAction {
    type: typeof SYNCHRONISATION;
    status: SyncStatus;
}

interface UpdateSynchronisePageAction {
    type: typeof SYNCHRONISATION_PAGE;
    page: number;
}

interface UpdateSynchroniseOpenTimeAction {
    type: typeof SYNCHRONISATION_OPEN_TIME;
    openTime: string;
}

interface UpdateSynchroniseUploadAction {
    type: typeof SYNCHRONISATION_UPLOADING;
    uploading: boolean;
}

export type SynchronisationActionTypes =
    UpdateSynchroniseAction |
    UpdateSynchronisePageAction |
    UpdateSynchroniseOpenTimeAction |
    UpdateSynchroniseUploadAction;

export interface SynchronisationState {
    status: SyncStatus;
    page: number;
    openTime: string | boolean;
    uploading: boolean;
}

export function updateSyncStatus(status: SyncStatus): SynchronisationActionTypes {
    return {
        type: SYNCHRONISATION,
        status,
    };
}

export function updateSyncPage(page: number): SynchronisationActionTypes {
    return {
        type: SYNCHRONISATION_PAGE,
        page,
    };
}

export function updateOpenTime(openTime: string): SynchronisationActionTypes {
    setOption("register_open_time", openTime);

    return {
        type: SYNCHRONISATION_OPEN_TIME,
        openTime,
    };
}
